import { createAction, props } from '@ngrx/store';

export * from './company-stratalot-type-generated.actions';

export const deleteOneCompanyStratalotTypeWithParams = createAction(
  '[CompanyStratalotType] Delete One CompanyStratalotType',
  props<{ idCompanyStratalotType: number; newIdCompanyStratalotType?: number }>()
);
